import API from '../app.api';

export const getUsers = async () => {
    const res = await API.get('/api/v1/admin/user-management/list');
    return res.data;
};

export const getUserInformation = async (userId) => {
    const res = await API.get(`/api/v1/admin/user/${userId}`);
    return res.data;
};

export const getInvitedUsers = async () => {
    const res = await API.get('/api/v1/admin/user-management/invite');
    return res.data;
};

export const inviteUser = async (rawData, isBusinessOwner = false) => {
    const res = await API({
        method: `post`,
        url: `/api/v1/admin/user-management/invite`,
        data: rawData,
    });
    return res.data;
};

export const resendUserInvite = async (inviteId) => {
    const res = await API({
        method: 'POST',
        url: `/api/v1/admin/user-management/invite/${inviteId}/resend`,
        data: {} 
    });
    return res.data;
}

export const deleteUserInvite = async (id) => {
    const res = await API({
        method: `delete`,
        url: `/api/v1/admin/user-management/invite/${id}`
    });
    return res.data;
};

export const getMaxPermissionForPortal = async (entityId, userId) => {
    const res = await API.get(`/api/v1/admin/user/${userId}/permission/max/portal`);
    return res.data;
};

export const updateUserEmail = async (userId, email) => {
    const res = await API.post(`/api/v1/admin/user/${userId}/email`, {email: email});
    return res.data;
};

export const getUpdateEmailToken = async (userId) => {
    const res = await API.get(`/api/v1/admin/user/${userId}/email`);
    return res.data;
};

// TODO - WHAT ARE BILLING CALLS DOING IN THIS FILE?????!!??

export const getBilling = async (limit = 20) => {
    const res = await API.get(`/api/v1/module/billing/entity/invoice?limit=${limit}`);
    return res.data;
};

export const getBalance = async (CustomerCode) => {
    const res = await API.get(`/api/v1/module/billing/entity/balance?customerCode=${CustomerCode}`);
    return res.data;
};

export const getPaymentMethod = async (pm = 'CreditCard') => {
    const res = await API.get(`/api/v1/module/billing/entity/payments/payment-method?paymentMethodType=${pm}`);
    return res.data;
};

export const newPaymentMethod = async (userProfile, limit = 20) => {
    const res = await API({
        method: `post`,
        url: `/api/v1/module/billing/entity/payments/setup-intent`,
        data: {}
    });
    return res.data;
};

export const createPayment = async (data) => {
    const res = await API.post(`/api/v1/module/billing/entity/payments/request`, { payments: data });
    return res.data;
};

export const deletePaymentMethod = async (data) => {
    const res = await API.post(`/api/v1/module/billing/entity/payments/payment-method/remove`, { paymentMethod: data.paymentMethod });
    return res.data;
};

export const deletePaymentIntent = async (setupIntent) => {
    const res = await API.post(`/api/v1/module/billing/entity/payments/setup-intent/remove`, { setupIntent: setupIntent.id });
    return res.data;
};

export const changeMyEmailAddress = async (email) => {
    const res = await API.post('/api/v1/common/user/email-change', { email });
    return res.data;
}
